import type IHttpEventHandler from "@/domain/ports/IHttpEventHandler";
import router from "@/router";
import paths from "@/router/paths";


export default class HttpEventHandler implements IHttpEventHandler {
  constructor() { }

  onUnAuthenticated() {
    router.push(`${paths.login}`);
  }

}
